import React, { useEffect, useRef } from 'react'
import { Provider, useDispatch } from 'react-redux'
import ReduxStore from '../../store'
import { obtenerAntecedentesCaso, obtenerDatosLlaves } from '../../store/actions/caso-general-action'
import { obtenerGrillaImplicado } from '../../store/actions/implicado-action'
import ImplicadoTerceros from './index'

// RG-576: el MISMO modal de ingreso y actualización de implicados de Caso General (ImplicadoTerceros) sin su grilla, para abrirlo
// desde otra pantalla de la aplicación anfitriona (la sección 1 del informe de defensa penal en defensa-gestion-externos).
// Se exporta como ImplicadoModalComponent desde src/index.js. Trae su propio store, que debe cargar el caso por sí mismo: las llaves
// (caso y organización), los antecedentes (fecha del siniestro y tipo de gestión) y la grilla de implicados (para la confirmación
// de «NO INFORMADO» al ingresar uno nuevo).
//   · idCaso, idOrgCaso — caso y organización.
//   · solicitud         — { esNuevo, idImplicado? }: cada objeto nuevo abre el modal (alta o edición de ese implicado).
//   · onCerrado         — al cerrar el modal.
//   · onGuardado        — cuando el servidor confirmó el alta o la actualización.

const CargaCaso = ({ idCaso, idOrgCaso, solicitud, onCerrado, onGuardado }) => {
  const dispatch = useDispatch()

  useEffect(() => {
    if (!idCaso || !idOrgCaso) return
    dispatch(obtenerDatosLlaves({ idCaso, idImplicado: 0, idOrgCaso }))
    const query = Buffer.from(JSON.stringify({ idOrgCaso, idCaso })).toString('base64')
    dispatch(obtenerAntecedentesCaso(query))
    dispatch(obtenerGrillaImplicado(query))
  }, [dispatch, idCaso, idOrgCaso])

  return <ImplicadoTerceros soloModal solicitud={solicitud} onCerrado={onCerrado} onGuardado={onGuardado} />
}

const ImplicadoModal = (props) => {
  // Un solo store por instancia: si se creara uno por render se perdería el caso cargado cada vez que el anfitrión se vuelva a dibujar.
  const store = useRef(null)
  if (!store.current) store.current = ReduxStore()

  return (
    <Provider store={store.current}>
      <CargaCaso {...props} />
    </Provider>
  )
}

export default ImplicadoModal
